export default __webpack_public_path__ + "static/media/reorder.32455281.svg";